import _ from 'lodash';
import postsByIndex from './postsByIndex';

let index = 0;
const posts = {};
postsByIndex.forEach((post) => {
  posts[post.path] = _.merge(post, {
    index,
  });
  index++;
});

export default posts;



// WEBPACK FOOTER //
// src/core/posts.js